import * as React from 'react';
import { Button, Well } from '@pushly/aqe/lib/components';
import { EditOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';
import { Container } from 'typescript-ioc/es5';
import * as randomstring from 'randomstring';
import { DomainDto } from '../../dtos/domain';
import { AppState } from '../../stores/app';
import { DomainService, NotificationService } from '../../services';
import { getClassNames } from '../../_utils/classnames';
import { NotificationAutoSuggestFields } from '../../enums/notification-auto-suggest-fields.enum';
import { titleCase } from '../../_utils/utils';
import NotificationAutomationEditor from './notification-automation-editor';

interface INotificationAutomationWell {
    title?: string,
    domain?: DomainDto,
    onDomainUpdated: (domain: Partial<DomainDto>) => void,
}

interface IState {
    showDrawer: boolean,
    drawerKey?: string,
}

class NotificationAutomationWell extends React.Component<INotificationAutomationWell, IState> {
    public state: IState = {
        showDrawer: false,
    };

    protected readonly appState: AppState;
    protected readonly notifService: NotificationService;
    protected readonly domainService: DomainService;

    public constructor(props: INotificationAutomationWell) {
        super(props);

        this.appState = Container.get(AppState);
        this.notifService = Container.get(NotificationService);
        this.domainService = Container.get(DomainService);
    }

    public render() {
        const domain = this.props.domain;

        const allFields = Object.values(NotificationAutoSuggestFields);
        const domainFields = domain?.notificationAutoSuggestFields ?? null;
        const fields = (domainFields ?? allFields)?.map(f =>
            titleCase(f.replace('_url', '')));

        return (
            <Well
                className="nested sw-v2-notif-automation-well"
                title="Automation"
                actions={(
                    <Button
                        size="small"
                        onClick={this.handleDrawerOpen}
                        disabled={!this.props.domain}
                    >
                        <EditOutlined />
                        <span>Edit</span>
                    </Button>
                )}
                hideFooter={true}
            >
                <Skeleton
                    loading={!this.props.domain}
                    active={true}
                    title={false}
                >
                    {!!this.props.domain && (
                        <>
                            <Well
                                title="Field Suggestions"
                                mode="ghost"
                                hideFooter={true}
                            >
                                <div className={getClassNames('form-layout-row')}>
                                    <div className={getClassNames('form-layout-row-label')}>
                                        Fields
                                    </div>
                                    <div className={getClassNames('form-layout-row-value')}>
                                        {fields.join(', ') || 'Field suggestions disabled'}
                                    </div>
                                </div>
                            </Well>

                            <NotificationAutomationEditor
                                visible={this.state.showDrawer}
                                domain={domain!}
                                onSubmit={async domainUpdate => {
                                    this.props.onDomainUpdated(domainUpdate);
                                    this.handleDrawerClose();
                                }}
                                onClose={this.handleDrawerClose}
                            />
                        </>
                    )}
                </Skeleton>
            </Well>
        );
    }

    protected get domain(): DomainDto | undefined {
        return this.props.domain;
    }

    protected handleDrawerOpen = () => {
        this.setState({ showDrawer: true, drawerKey: randomstring.generate() });
    };

    protected handleDrawerClose = () => {
        this.setState({ showDrawer: false });
    };
}

export default NotificationAutomationWell;
